import { usePathname } from '@/i18n/routing';

export const useSidebarLink = (onClose?: () => void) => {
  const pathname = usePathname();

  return (e: React.MouseEvent, targetPath: string) => {
    if (pathname === targetPath) {
      e.preventDefault();
      onClose?.();
    }
  };
};
